import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Flame } from "lucide-react";

export default function Cancel() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 py-20">
      <div
        data-testid="cancel-page"
        className="w-full max-w-xl bg-[#0f0f0f] border border-white/10 p-10 md:p-14 text-center"
      >
        <div className="flex justify-center mb-6">
          <Flame className="w-8 h-8 text-[#FF3B30]" />
        </div>
        <XCircle className="w-14 h-14 text-[#FF3B30] mx-auto" />
        <h1 className="font-['Anton'] text-5xl uppercase tracking-tight text-white mt-6 leading-none">
          Checkout Canceled
        </h1>
        <p className="font-['Outfit'] text-zinc-400 mt-3">
          No worries — your cart's still saved. Come back when you're hungry.
        </p>
        <Link
          to="/"
          data-testid="cancel-home-link"
          className="inline-flex mt-10 items-center font-['Anton'] tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 text-sm transition-colors"
        >
          Back to Menu
        </Link>
      </div>
    </div>
  );
}
